export type IGenerateJasperReport = (
  url: string,
  element: JQuery<HTMLElement> | HTMLElement,
  appContext: string,
  loadingText: string,
  finishText: string,
  successClass?: string,
  placeInside?: boolean,
  appendDownloadButton?: boolean,
  callbackFn?: IDCA.IGenericFunc
) => void;

export function generateJasperReport(
  url: string,
  element: JQuery<HTMLElement> | HTMLElement,
  appContext: string,
  loadingText: string,
  finishText: string,
  successClass = '',
  placeInside = true,
  appendDownloadButton = false,
  callbackFn?: () => any
) {
  const { langObj = {} } = window.DexeroCoreApp.options;
  const $element = $(element);
  const c = $element.attr('class');
  const tp = $element.data('placement') || 'left';

  function allowSpacesFilterFn() {
    // @ts-ignore
    return this.nodeType === Node.TEXT_NODE && /\S/.test(this.nodeValue) !== false;
  }
  const allowSpaces = !!$element.contents().filter(allowSpacesFilterFn).length;
  const spacer = allowSpaces ? '&nbsp' : '';
  let downloadButton;

  $element.tooltip('destroy');
  if (!appendDownloadButton) {
    $element.addClass('hide');
  }
  downloadButton = `<a rel="tooltip" class="${c}" href="#" data-container="body" data-placement="${tp}" data-original-title="${loadingText}" onclick="return false;">${
    placeInside !== true ? spacer : ''
  }<span class="fa fa-refresh fa-spin" aria-hidden="true"></span>${
    placeInside === true ? ` ${langObj.progressText}` : spacer
  }</a>`;

  $(downloadButton).insertAfter($element[0]);
  $.ajax({
    url,
    success(data) {
      $element.next().tooltip('destroy');
      $element.next().remove();
      // If we don't get back a valid report link we need to show error
      if (data === '') {
        $element.removeClass('hide');
        window.DexeroCoreApp.userToastMsg('error', langObj.errorText, '');
        return;
      }
      downloadButton = `<a rel="tooltip" class="${successClass ||
        c}" href="${data}" target="_blank" data-container="body" data-placement="${tp}" data-original-title="${finishText}">${
        placeInside !== true ? spacer : ''
      }<span class="fa fa-download" aria-hidden="true"></span>${
        placeInside === true ? ` ${finishText}` : spacer
      }</a>`;

      $(downloadButton).insertAfter($element[0]);
      if (!appendDownloadButton) {
        $element.remove();
      } else {
        $element.removeClass('hide');
      }
      // Run callback function
      if (typeof callbackFn === 'function') {
        callbackFn();
      }
    },
  });
}
